import React, { useState, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";
import { useLocation } from "react-router-dom";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  Logo,
  BtnWrap,
  NavButton,
} from "./NavbarElements";
import ShiftITLogo from "../../images/ShiftITLogo.png";

const Navbar = ({ toggle }) => {
  const [scrollNav, setScrollNav] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  const sectionLinkProps = (section) =>
    isHomePage
      ? {
          to: section,
          smooth: true,
          duration: 500,
          spy: true,
          exact: "true",
          offset: -80,
        }
      : { as: "a", href: `/#${section}` };

  useEffect(() => {
    changeNav();
    window.addEventListener("scroll", changeNav);

    return () => {
      window.removeEventListener("scroll", changeNav);
    };
  }, []);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo to="/" onClick={toggleHome}>
              <Logo src={ShiftITLogo} alt="Shift IT Logo" />
            </NavLogo>
            <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLinks {...sectionLinkProps("about")}>About</NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks {...sectionLinkProps("services")}>Services</NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks as="a" href="/contact">
                  Contact
                </NavLinks>
              </NavItem>
              <BtnWrap style={{ display: "none" }}>
                <NavButton
                  href="https://portal.shift-it.io"
                  primary={true}
                  dark={true}
                  target="_blank"
                >
                  Client Portal
                </NavButton>
              </BtnWrap>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};
export default Navbar;
